module.exports = __webpack_public_path__ + "static/media/ImporterFeature7.116cc1c4.svg";